<div id="section-plans">
  <div class="container">
    <div class="row">
      @for (plan of plans; track plan) {
        <div class="col-lg-4">
          <div
            class="container-plan"
            [class.integrated]="plan.id === 'integrated'"
            [class.premium]="plan.id === 'premium'"
          >
            <div class="plan-title">
              {{ plan.titleKey | translate }}
            </div>
            <ul class="list-group">
              @for (feature of plan.features; track feature) {
                <li class="list-group-item" [class.item-desactive]="!feature.isEnabled">
                  {{ feature.name | translate }}
                  <div class="icon d-block" [class.cancel]="!feature.isEnabled">
                    <fa-icon [icon]="feature.getIcon()"></fa-icon>
                  </div>
                </li>
              }
            </ul>
          </div>
        </div>
      }
    </div>
  </div>
</div>
